import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-white py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto text-gray-800 space-y-6">
        <h1 className="text-3xl font-bold text-center mb-8">Privacy Policy</h1>
        
        <p>
          This privacy policy applies to Karawan, a carpooling app owned and operated by Karawan. By using our app, you consent to the collection, use, and sharing of your personal information as described in this policy.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-3">COLLECTION OF INFORMATION</h2>
        <p>We collect information about you when you use our app, including:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li><strong>Personal information you provide:</strong> When you create an account, we may collect your name, email address, phone number, and other personal information.</li>
          <li><strong>Location data:</strong> When you use our app, we may collect your precise location data from your device.</li>
          <li><strong>Transaction data:</strong> We collect information about the rides you request and take through our app, including the pickup and drop-off locations, distance travelled, and cost of the ride.</li>
          <li><strong>Device information:</strong> We collect information about the device you use to access our app, including the model, operating system, and IP address.</li>
        </ul>

        <h2 className="text-xl font-semibold mt-6 mb-3">USE OF INFORMATION</h2>
        <p>We use the information we collect to provide and improve our app, including:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li><strong>Facilitating carpooling:</strong> We use your personal information, location data, and transaction data to match you with other users who are going to the same destination and to facilitate carpooling.</li>
          <li><strong>Personalizing your experience:</strong> We may use your personal information and location data to provide recommendations and personalized content.</li>
          <li><strong>Analysing and improving our app:</strong> We may use your personal information, location data, transaction data, and device information to analyse and improve our app, including by analysing user behaviour and trends.</li>
          <li><strong>Research and development:</strong> We may use your personal information, location data, transaction data, and device information for research and development purposes, such as to improve our algorithms and machine learning models.</li>
          <li><strong>Marketing and advertising:</strong> We may use your personal information and location data to personalize the advertisements and offers you see through our app or other channels, such as email or social media.</li>
        </ul>

        <h2 className="text-xl font-semibold mt-6 mb-3">SHARING OF INFORMATION</h2>
        <p>We may share your personal information with third parties for the following purposes:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li><strong>With service providers:</strong> We may share your personal information with service providers who assist us with providing our app and related services, such as payment processing and customer support.</li>
          <li><strong>With affiliates:</strong> We may share your personal information with our affiliates for the purposes described in this Policy.</li>
          <li><strong>As required by law:</strong> We may disclose your personal information if we are required to do so by law or in response to a legal request.</li>
        </ul>

        <h2 className="text-xl font-semibold mt-6 mb-3">YOUR RIGHTS</h2>
        <p>You have the following rights in relation to your personal information:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li><strong>Access:</strong> You have the right to access the personal information we hold about you and to request a copy of it.</li>
          <li><strong>Correction:</strong> You have the right to request that we correct any inaccurate or incomplete personal information we hold about you.</li>
          <li><strong>Deletion:</strong> You have the right to request that we delete the personal information we hold about you, subject to certain exceptions.</li>
          <li><strong>Objection:</strong> You have the right to object to our processing of your personal information for certain purposes, such as marketing or research and development.</li>
          <li><strong>Restriction:</strong> You have the right to request that we restrict the processing of your personal information in certain circumstances.</li>
          <li><strong>Portability:</strong> You have the right to request that we transfer your personal information to another organization or to you, in a structured, commonly used, and machine-readable format.</li>
        </ul>

        <h2 className="text-xl font-semibold mt-6 mb-3">OPT-OUTS</h2>
        <p>You may opt out of certain uses of your personal information as follows:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li><strong>Marketing communications:</strong> You may opt out of receiving marketing communications from us by following the unsubscribe instructions included in such communications or by contacting us at karawanofficial@gmail.com.</li>
          <li><strong>Research and development:</strong> If you do not want your personal information to be used for research and development purposes, you may opt out by contacting us at karawanofficial@gmail.com.</li>
        </ul>

        <h2 className="text-xl font-semibold mt-6 mb-3">COOKIES AND SIMILAR TECHNOLOGIES</h2>
        <p>
          We may use cookies and similar technologies to collect and store information about your use of our app. You can disable cookies in your browser settings, but doing so may affect the functionality of our app.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-3">CHILDREN'S PRIVACY</h2>
        <p>
          Our app is not intended for children under the age of 13. We do not knowingly collect personal information from children under 13. If we become aware that we have collected personal information from a child under 13, we will delete it in accordance with applicable law.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-3">USER INQUIRIES</h2>
        <p>
          If you have any questions or concerns about your personal information or this Policy, please contact us at karawanofficial@gmail.com. We will respond to your inquiries in a timely manner.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-3">SECURITY</h2>
        <p>
          We take reasonable steps to protect your personal information from unauthorized access, use, or disclosure. However, no security measures are perfect, and we cannot guarantee the security of your personal information.
        </p>

        <div className="bg-gray-100 p-4 rounded-md my-6 text-sm font-semibold uppercase">
          PLEASE NOTE THAT WE ARE NOT RESPONSIBLE FOR ANY ACCIDENTS, INJURIES, OR THEFTS THAT MAY OCCUR WHILE USING OUR APP OR WHILE CARPOOLING WITH OTHER USERS. YOU ARE RESPONSIBLE FOR YOUR OWN SAFETY AND SHOULD TAKE APPROPRIATE PRECAUTIONS WHEN USING OUR APP OR CARPOOLING WITH OTHERS.
        </div>

        <h2 className="text-xl font-semibold mt-6 mb-3">CHANGES TO THIS POLICY</h2>
        <p>
          We may update this privacy policy from time to time. We will post any changes on this page and encourage you to review the policy periodically.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-3">CONTACT US</h2>
        <p>
          If you have any questions or concerns about our privacy policy, please contact us at karawanofficial@gmail.com
        </p>

        <p className="mt-8">
          By using our app, you consent to the collection, use, and sharing of your personal information as described in this Policy. If you do not agree with our policies and practices, do not use our app.
        </p>
        <p>
          Your continued use of our app after we make changes to this Policy will be deemed as your acceptance of those changes.
        </p>
        <p className="text-sm text-gray-500 mt-4">
          This Policy was last updated on 22nd Dec, 2022.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
